import { createFileRoute } from '@tanstack/react-router'
import { AdminReportsPage } from '@/features/reports/pages/admin-reports-page'
import { createTableSearchSchema } from '@/lib/data-table/search-schema'

const reportsSearchSchema = createTableSearchSchema({
  defaultPageSize: 25,
  sortIds: ['created_at', 'priority', 'reason'],
  filterKeys: ['status', 'reason', 'target_type', 'from', 'to'],
})

export const Route = createFileRoute('/reports')({
  staticData: { title: 'Reports' },
  validateSearch: reportsSearchSchema,
  component: AdminReportsPage,
})
